var initFullscreen = function (container) {
    var windowHeight = $(window).height();
    $(container).height(windowHeight);
};

jQuery(document).ready(function($){
    initFullscreen('.fullscreen');
    $(window).on('resize', function(){
        initFullscreen('.fullscreen');
    });
});